import { Dialog, DialogContent, DialogActions, Box } from "@mui/material";
import { useState, useEffect } from "react";
import { updatePermisionario } from "../../components/functions/Projects";
import CustomButton from "../../ui/button/Button";

const EditPermisionarioModal = ({
  API_URL,
  open,
  onClose,
  onConfirm,
  permisionario,
}) => {
  const [permisionarioForm, setPermisionarioForm] = useState(null);

  useEffect(() => {
    if (open) {
      setPermisionarioForm(permisionario);
    }
  }, [open]);

  const handleConfirm = async () => {
    if (!permisionarioForm) return;

    if (
      !permisionarioForm.razonSocial ||
      permisionarioForm.razonSocial.trim() === ""
    ) {
      return;
    }

    try {
      await updatePermisionario(API_URL, permisionarioForm);
      onConfirm(true, permisionarioForm);
    } catch (error) {
      onConfirm(false, permisionario);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogContent>
        <div>
          <h2>Editar Permisionario</h2>
          <Box
            className="stepper-step-content"
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              width: "100%",
            }}
          >
            <div
              className="d-grid align-items-center"
              style={{ gridTemplateColumns: "250px 1fr", rowGap: "16px" }}
            >
              <label className="form-label">Nombre:</label>
              <input
                className="form-input"
                type="text"
                placeholder="Ingresa el nombre..."
                value={permisionarioForm?.razonSocial || ""}
                onChange={(e) =>
                  setPermisionarioForm((prev) => ({
                    ...prev,
                    razonSocial: e.target.value,
                  }))
                }
              />
              <label className="form-label">Nombre corto:</label>
              <input
                className="form-input"
                type="text"
                placeholder="Ingresa el nombre corto..."
                value={permisionarioForm?.alias || ""}
                onChange={(e) =>
                  setPermisionarioForm((prev) => ({
                    ...prev,
                    alias: e.target.value,
                  }))
                }
              />
            </div>
          </Box>
        </div>
      </DialogContent>
      <DialogActions>
        <CustomButton
          background={"#FFFFFF"}
          color={"#223D51"}
          text="Cancelar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          type="button"
          width={"100px"}
          onClick={onClose}
        />
        <CustomButton
          className="notifications-button"
          text={"Guardar"}
          color={"#FFFFFF"}
          background={"#223D51"}
          fontStyle={"normal"}
          fontWeight={500}
          fontSize={"14px"}
          height={"40px"}
          type={"button"}
          onClick={handleConfirm}
        />
      </DialogActions>
    </Dialog>
  );
};

export default EditPermisionarioModal;
